import { baseApi } from '@klp/core/api';

import { contractLeaseAgreementApiRoutes } from './api';
import type {
    ContractLeaseAgreementRequest,
    ContractLeaseAgreementResponse,
} from './types';
import { parseContractLeaseAgreement } from './utils';

export const contractLeaseAgreementApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getContractLeaseAgreement: builder.query<
            ContractLeaseAgreementResponse,
            ContractLeaseAgreementRequest
        >({
            query: (requestParams) => ({
                url: contractLeaseAgreementApiRoutes.list(
                    requestParams.kundeNummer!,
                ),
            }),
            transformResponse: (
                response: unknown,
            ): ContractLeaseAgreementResponse => {
                const contractLeaseAgreement =
                    parseContractLeaseAgreement(response);
                return { contractLeaseAgreement };
            },
            providesTags: (_result, _error, arg) => [
                { type: 'LeaseAgreement', id: arg.kundeNummer },
            ],
        }),
    }),
});

export const {
    useGetContractLeaseAgreementQuery,
    useLazyGetContractLeaseAgreementQuery,
} = contractLeaseAgreementApi;
